import {React} from 'react';
import Routes from './Routes';
import './styles/App.css';

  let pathname = window.location.pathname;
  let simType = pathname.indexOf("/im") !== -1 || pathname.indexOf("/IM") !== -1
    ? "im"
    : pathname.indexOf("/fc") !== -1 || pathname.indexOf("/FC") !== -1
    ? "fc"
    : pathname.indexOf("/pm") !== -1 || pathname.indexOf("/PM") !== -1
    ? "pm"
    : pathname.indexOf("/qm") !== -1 || pathname.indexOf("/QM") !== -1
    ? "qm"
    : pathname.indexOf("/scm") !== -1 || pathname.indexOf("/SCM") !== -1
    ? "scm"
    : "";

  export const getSimType = () => simType;

  export const getSessionKey = () => {
    let sessionPrefix = "session_id";
    if(pathname.toLowerCase().includes("/prework")) sessionPrefix = "prework_session_id";
    if(pathname.toLowerCase().includes("/reflection")) sessionPrefix = "reflection_session_id";
    return `${simType}_${sessionPrefix}`;
  };

  export const getSession = () => {
    return localStorage.getItem(getSessionKey()) || null;
  };

  export const setSession = (newSessionId) => {
    if(newSessionId) {
      localStorage.setItem(getSessionKey(), newSessionId);
    }
  };

function App() {
  return (
    <div className={`App ${simType}`}>
       <Routes />
    </div>
  );
}

export default App;
